(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"), require("dompurify"), require("pikaday"), require("numbro"));
	else if(typeof define === 'function' && define.amd)
		define("Handsontable", ["moment", "dompurify", "pikaday", "numbro"], factory);
	else if(typeof exports === 'object')
		exports["Handsontable"] = factory(require("moment"), require("dompurify"), require("pikaday"), require("numbro"));
	else
		root["Handsontable"] = factory(root["moment"], root["DOMPurify"], root["Pikaday"], root["numbro"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__82__, __WEBPACK_EXTERNAL_MODULE__367__, __WEBPACK_EXTERNAL_MODULE__460__, __WEBPACK_EXTERNAL_MODULE__474__) {
return 